module.exports = __webpack_public_path__ + "static/media/null-img.e9228012.png";